// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3uOOE","header":"PatientBlock_header__WOlAi","label":"PatientBlock_label__3A9z2","option":"PatientBlock_option__1SbyK"};